exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-item {\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  margin-top: 10px;\r\n}\r\n.search-item > label {\r\n  margin: 0;\r\n  margin-right: 5px;\r\n}\r\n.box-position {\r\n  float: left;\r\n  margin-left: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/activity/settingCourse.component.css
// module id = ../../../../../src/app/activity/settingCourse.component.css
// module chunks = main